import { cn } from '@seen/ui'
import type { JSX, ReactNode } from 'react'

export interface ActivityListProps {
  children: ReactNode
}

export function ActivityList({ children }: ActivityListProps): JSX.Element {
  return (
    <div
      className={cn(
        'relative flex flex-col gap-4',
        [
          'before:content-[""]',
          'before:absolute',
          'before:left-5',
          'before:top-0',
          'before:bottom-0',
          'before:w-px',
          'before:bg-border',
        ],
        'isolate' // ActivityEntry & ActivityComment have z-10
      )}
    >
      {children}
    </div>
  )
}
